import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0a36153b = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _a18fbd88 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _ab25e2be = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _13e198c8 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _13c569c6 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _138d0bc2 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _1370dcc0 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _2af56edd = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _5fde2476 = () => interopDefault(import('..\\pages\\patient\\eligibility.vue' /* webpackChunkName: "pages_patient_eligibility" */))
const _208e391c = () => interopDefault(import('..\\pages\\patient\\patient-information.vue' /* webpackChunkName: "pages_patient_patient-information" */))
const _445aaf3b = () => interopDefault(import('..\\pages\\patient\\success.vue' /* webpackChunkName: "pages_patient_success" */))
const _31a6a26d = () => interopDefault(import('..\\pages\\pharmacy\\eligibility.vue' /* webpackChunkName: "pages_pharmacy_eligibility" */))
const _efce7478 = () => interopDefault(import('..\\pages\\pharmacy\\patient-information.vue' /* webpackChunkName: "pages_pharmacy_patient-information" */))
const _d9d6103a = () => interopDefault(import('..\\pages\\pharmacy\\success.vue' /* webpackChunkName: "pages_pharmacy_success" */))
const _732011f6 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _0a36153b,
    name: "error"
  }, {
    path: "/rejection",
    component: _a18fbd88,
    name: "rejection"
  }, {
    path: "/unlock",
    component: _ab25e2be,
    name: "unlock"
  }, {
    path: "/errors/400",
    component: _13e198c8,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _13c569c6,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _138d0bc2,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _1370dcc0,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _2af56edd,
    name: "errors-500"
  }, {
    path: "/patient/eligibility",
    component: _5fde2476,
    name: "patient-eligibility"
  }, {
    path: "/patient/patient-information",
    component: _208e391c,
    name: "patient-patient-information"
  }, {
    path: "/patient/success",
    component: _445aaf3b,
    name: "patient-success"
  }, {
    path: "/pharmacy/eligibility",
    component: _31a6a26d,
    name: "pharmacy-eligibility"
  }, {
    path: "/pharmacy/patient-information",
    component: _efce7478,
    name: "pharmacy-patient-information"
  }, {
    path: "/pharmacy/success",
    component: _d9d6103a,
    name: "pharmacy-success"
  }, {
    path: "/",
    component: _732011f6,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
